import { GameFormatPoll } from "./GameFormatPoll";

export function PollRequiredPage({ poll }) {
  return (
    <main className="poll-required-page" data-testid="poll-required-page">
      <div className="poll-required-brand" data-testid="poll-required-brand">
        PELADA DOS PERNINHAS FC
      </div>
      <GameFormatPoll blocking poll={poll} />
    </main>
  );
}